import React from "react";
import { Select, DatePicker, Space, notification } from "antd";
import { INTERNAL_STATUSES } from "../../constants/status";
import moment from "moment";

const NextDayRemittanceOrderFilters = ({ filters, onFiltersChange }) => {

  const today = moment();
  const oneWeekAgo = moment().subtract(7, "days");

  return (
    <Space size="large" wrap>

      <div>
        Sort By :{` `}
        <Select
          placeholder="Sort By"
          style={{ width: 200 }}
          allowClear
          defaultValue="deliveredDate"
          onChange={(value) =>
            onFiltersChange({
              ...filters,
              sortBy: value,
              startDate: value === "paymentDate" || value === "deliveredDate" ? undefined : filters.startDate || oneWeekAgo,
              endDate: value === "paymentDate" || value === "deliveredDate" ? undefined : filters.endDate || today,
              paymentStartDate:
                value === "createdDate" || value === "deliveredDate" ? undefined : filters.paymentStartDate || oneWeekAgo,
              paymentEndDate: value === "createdDate" || value === "deliveredDate" ? undefined : filters.paymentEndDate || today,
              deliveredStartDate:
                value === "createdDate" || value === "paymentDate" ? undefined : filters.deliveredStartDate || oneWeekAgo,
              deliveredEndDate: value === "createdDate" || value === "paymentDate" ? undefined : filters.deliveredEndDate || today,
            })
          }
        >
          <Select.Option value="paymentDate">Payment Date</Select.Option>
          <Select.Option value="createdDate">Created Date</Select.Option>
          <Select.Option value="deliveredDate">Delivered Date</Select.Option>
        </Select>
      </div>

      {filters.sortBy === "createdDate" && (
        <div>
          Order At :{` `}
          <DatePicker.RangePicker
            allowClear={false}
            allowEmpty={false}
            value={[filters.startDate, filters.endDate]}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], "days") > 90) {
                notification.error({
                  message: "Date Range cannot be more than 90 days.",
                  placement: "bottomRight",
                });
                return false;
              }

              dates
                ? onFiltersChange({
                  ...filters,
                  startDate: dates[0],
                  endDate: dates[1],
                  paymentStartDate: undefined,
                  paymentEndDate: undefined,
                  deliveredStartDate: undefined,
                  deliveredEndDate: undefined
                })
                : onFiltersChange({
                  ...filters,
                  startDate: undefined,
                  endDate: undefined,
                });
            }}
          />
        </div>
      )}

      {filters.sortBy === "paymentDate" && (
        <div>
          Checkout At :{` `}
          <DatePicker.RangePicker
            allowClear={false}
            allowEmpty={false}
            value={[filters.paymentStartDate, filters.paymentEndDate]}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], "days") > 90) {
                notification.error({
                  message: "Date Range cannot be more than 90 days.",
                  placement: "bottomRight",
                });
                return false;
              }

              dates
                ? onFiltersChange({
                  ...filters,
                  paymentStartDate: dates[0],
                  paymentEndDate: dates[1],
                  startDate: undefined,
                  endDate: undefined,
                  deliveredStartDate: undefined,
                  deliveredEndDate: undefined
                })
                : onFiltersChange({
                  ...filters,
                  paymentStartDate: undefined,
                  paymentEndDate: undefined,
                });
            }}
          />
        </div>
      )}

      {filters.sortBy === "deliveredDate" && (
        <div>
          Delivered At :{` `}
          <DatePicker.RangePicker
            allowClear={false}
            allowEmpty={false}
            value={[filters.deliveredStartDate, filters.deliveredEndDate]}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], "days") > 90) {
                notification.error({
                  message: "Date Range cannot be more than 90 days.",
                  placement: "bottomRight",
                });
                return false;
              }

              dates
                ? onFiltersChange({
                  ...filters,
                  deliveredStartDate: dates[0],
                  deliveredEndDate: dates[1],
                  startDate: undefined,
                  endDate: undefined,
                  paymentStartDate: undefined,
                  paymentEndDate: undefined,
                })
                : onFiltersChange({
                  ...filters,
                  deliveredStartDate: undefined,
                  deliveredEndDate: undefined,
                });
            }}
          />
        </div>
      )}

      <div>
        Remitted :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          defaultValue="false"
          onChange={(value) =>
            onFiltersChange({ ...filters, isRemittance: value })
          }
        >
          <Select.Option value="true">Yes</Select.Option>
          <Select.Option value="false">No</Select.Option>
        </Select>
      </div>

      <div>
        Internal Status :{" "}
        <Select
          placeholder="ALL"
          defaultValue="Delivered"
          style={{ width: 200 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, internalStatus: value })
          }
        >
          {INTERNAL_STATUSES.map((status) => (
            <Select.Option key={status} value={status}>
              {status}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Space>
  );
};

export default NextDayRemittanceOrderFilters;
